<template>
  <div class="uid-intro">
    <div class="popup-shadow" @click="hidePopup"></div>
    <div class="popup-container">
      <a href="javascript:void(0);" class="popup-close" @click="hidePopup"></a>
      <div class="popup-main">
        <p class="uid-title">{{ letter.v3TokenTip }}</p>
        <div class="uid-intro-wrap">
          <img
            class="uid-intro-img"
            src="../../../assets/image/officialTopupNew/common/login/otp-intro.png"
            alt="otp"
          />
          <p class="uid-intro-tip">{{ letter.v3tokenKey }}</p>
        </div>
        <p class="uid-intro-text">{{ letter.v3TokenIntro1 }}</p>
        <p class="uid-intro-text">{{ letter.v3TokenIntro2 }}</p>
        <p class="uid-get-title">{{ letter.v3HowToGetToke }}</p>
        <div class="otp-step" v-for="(item, index) in otpStepList" :key="index">
          <p v-if="item.type === 'text'" class="otp-step-text">
            {{ item.value }}
          </p>
          <img
            v-if="item.type === 'img'"
            class="otp-step-img"
            :src="item.value"
            :alt="item.value"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { mapState } from 'vuex';
export default {
  name: 'UidTokenGuidePopup',
  computed: {
    ...mapState({
      letter: state => state.letter,
      gameId: state => state.gameId,
      lang: state => state.lang,
      otpLangJson: state => state.page.otpLangJson,
      otpPicList: state => state.page.otpPicList
    }),
    otpStepList() {
      try {
        const renderList = [];
        const otpText = this.otpLangJson?.[this.lang] || {};
        const otpPic = this.otpPicList || {};
        const loopLength = Math.max(
          Object.keys(otpText)?.length,
          Object.keys(otpPic)?.length
        );
        for (let i = 0; i < loopLength; i++) {
          const key = `step${i + 1}`;
          otpText?.[key] &&
            renderList.push({
              type: 'text',
              value: otpText[key] || ''
            });
          otpPic?.[key] &&
            renderList.push({
              type: 'img',
              value: otpPic[key] || ''
            });
        }
        return renderList;
      } catch (e) {
        console.error('Otp config parse error', e);
        return [];
      }
    }
  },
  methods: {
    hidePopup() {
      this.$emit('hidePopup');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopupNew/officialTopupNew.scss';
.uid-intro {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1001;
  width: 100%;
  height: 100%;
}
.uid-title {
  margin-bottom: 40px;
  font-size: 28px;
  font-weight: bold;
  text-align: center;
  color: #414141;
}
.uid-intro-wrap {
  position: relative;
}
.uid-intro-img {
  display: block;
  width: 100%;
  height: auto;
  margin: 0 auto 10px;
}
.uid-intro-tip {
  position: absolute;
  top: 30px;
  left: 20px;
  font-size: 24px;
  font-weight: bold;
  color: rgb(95, 209, 147);
}
.uid-intro-text {
  font-size: 20px;
  line-height: 1.5;
  color: #707070;
}
.uid-get-title {
  margin-top: 60px;
  margin-bottom: 40px;
  font-size: 28px;
  font-weight: bold;
  text-align: center;
  color: #414141;
}
.otp-step {
  margin-bottom: 20px;
  &-text {
    margin-bottom: 10px;
    font-size: 24px;
    color: #707070;
  }
  &-img {
    box-sizing: border-box;
    width: 100%;
    height: auto;
    margin: 0 auto 20px;
    padding: 10px;
    background-color: #fff;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.4);
  }
}
.popup-shadow {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
}
.popup-container {
  overflow: hidden;
  position: absolute;
  left: 50%;
  top: 50%;
  box-sizing: border-box;
  padding: 76px 22px;
  width: 90%;
  height: 90%;
  background-size: 100% 100%;
  color: var(--login-uidtoken-guide-popup-tip);
  transform: translate(-50%, -50%);
  // @psetbg ('coupon-popup-bg.png', false, false);
  background-color: #f3f3f3;
}
.popup-main {
  box-sizing: border-box;
  overflow: auto;
  width: 100%;
  height: 100%;
  padding: 0 20px;
}
.popup-close {
  position: absolute;
  cursor: pointer;
  right: 32px;
  top: 27px;
  background: url($commonImg + 'close.png') no-repeat;
  width: 28px;
  height: 28px;
}

#ssr-page.landscape {
  .popup-container {
    width: 620px;
  }
}
</style>
